import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '~/lib/useAuth';
import { LoginPage } from './auth/LoginPage';
import { AuthCallback } from './auth/AuthCallback';
import { Shell } from './layout/Shell';
import { Dashboard } from './pages/Dashboard';
import { Trips } from './pages/Trips';
import { TripEditor } from './pages/TripEditor';
import { BusinessInfo } from './pages/BusinessInfo';
import { Bookings } from './pages/Bookings';
import { Anglers } from './pages/Anglers';
import { BookingSettings } from './pages/BookingSettings';
import { Stub } from './pages/Stub';

function ProtectedRoutes() {
  const { session } = useAuth();
  if (!session) return <Navigate to="/login" replace />;
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/trips/:slug" element={<TripEditor />} />
        <Route
          path="/lodging"
          element={<Stub title="Lodging" eyebrow="Catalog" note="Lodging editor lands next — iCal sync wires up here once Adam's Airbnb feeds are in." />}
        />
        <Route
          path="/packages"
          element={<Stub title="Packages" eyebrow="Catalog" note="Curated Trip + Lodging bundles. CRUD lands after Lodging editor." />}
        />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/anglers" element={<Anglers />} />
        <Route
          path="/mailbag"
          element={<Stub title="Mailbag" eyebrow="Operations" note="Inquiry inbox. Hot / Tire-kicker priority tags. Quick-reply templates." />}
        />
        <Route
          path="/ledger"
          element={<Stub title="The Ledger" eyebrow="Business" note="Stripe payments + cash + refunds. Reconciliation view." />}
        />
        <Route
          path="/field-notes"
          element={<Stub title="Field Notes" eyebrow="Catalog" note="Blog CMS — Markdown editor + scheduling + view counts." />}
        />
        <Route path="/settings/business-info" element={<BusinessInfo />} />
        <Route path="/settings/booking" element={<BookingSettings />} />
        <Route
          path="/settings"
          element={<Stub title="Settings" eyebrow="Admin" note="Business Info and Booking are live — see the sidebar. More settings (users, integrations) coming." />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/*" element={<ProtectedRoutes />} />
    </Routes>
  );
}
